// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"61db345c","453":"ac6f742b","455":"cdd9fe4e","977":"9b45e164"}[chunkId] + ".chunk.js";
};